module.exports = __webpack_public_path__ + "static/img/news10.8530750.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news10.png
// module id = 5/u2
// module chunks = 1